import ExtendableError from 'es6-error';
import { createResource } from '@gandi/resource/redux';
import { createLogger } from 'gandi.redux-logger';
export const STATE_PATH = 'cart.inAppPurchase';
export const logger = createLogger('@gandi/cart/in-app-purchase');
export const resource = createResource('@gandi/cart/in-app-purchase', {});
export const initialPurchaseState = () => ({
  cartId: undefined,
  products: [],
  isFailure: false,
  errors: undefined
});
export const initialState = () => ({
  carts: {},
  purchases: {}
});
export const startLabel = purchaseId => `start-${purchaseId}`;
export const fetchCartLabel = purchaseId => `fetch-cart-${purchaseId}`;
export const addProductLabel = purchaseId => `add-product-${purchaseId}`;
export const confirmLabel = purchaseId => `confirm-${purchaseId}`;
export const cancelLabel = purchaseId => `cancel-${purchaseId}`;
export class UnexpectedLabelError extends ExtendableError {
  constructor(actionCreator, payload) {
    super(`Action ${actionCreator.getType()} received an unexpected payload`);
    this.actionCreator = actionCreator;
    this.payload = payload;
  }
}